import * as React from 'react';
import Modal from '../Modal';
import { Link } from 'react-router-dom';
import HeaderButton from 'components/partials/HeaderButton';
import Icon from 'theme/Icon';
import TPP from 'hooks/TPP';

import './style.less';

const $R = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/routes`);

export default class SubModal extends Modal {
  render() {
    const { children, width, classes } = this.props;
    const style = {
      display: 'flex',
      flexDirection: 'column',
    };

    return this.isOpened() ? (
      <div className='modal modal-sub add-to-basket-modal tfs'>
        <div
          className={`inner addBasket ${classes && classes}`}
          style={{
            width: width + '%',
            ...style,
          }}
        >
          <div>{children}</div>
          <div>
            <HeaderButton classes='header-item right'>
              <Link to={$R.MAIN_HOME.path}>
                <div>
                  <button className='keep-shopping'>
                    <TPP path='ADD_TO_BASKET_MODAL_TEXTS.KEEP_SHOPPING' />
                  </button>
                </div>
              </Link>
            </HeaderButton>
            <HeaderButton classes='header-item'>
              <Link to={$R.BASKET.path}>
                <div>
                  <button className='go-to-basket'>
                    <TPP path='ADD_TO_BASKET_MODAL_TEXTS.GO_TO_BASKET' />
                    <Icon icon='sepet' />
                  </button>
                </div>
              </Link>
            </HeaderButton>
          </div>
        </div>
      </div>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./src/theme/AddToBasketModalTFS/index.js